/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicTournamentRosterPlayer
 */
export interface PublicTournamentRosterPlayer {
    /**
     * Player identity shared with public match-operation snapshots
     * @type {string}
     * @memberof PublicTournamentRosterPlayer
     */
    id: string;
    /**
     * Public minimized label with given names and family-name initials; never raw family names
     * @type {string}
     * @memberof PublicTournamentRosterPlayer
     */
    displayName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicTournamentRosterPlayer
     */
    playerNumber?: number | null;
}

/**
 * Check if a given object implements the PublicTournamentRosterPlayer interface.
 */
export function instanceOfPublicTournamentRosterPlayer(value: object): value is PublicTournamentRosterPlayer {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PublicTournamentRosterPlayerFromJSON(json: any): PublicTournamentRosterPlayer {
    return PublicTournamentRosterPlayerFromJSONTyped(json, false);
}

export function PublicTournamentRosterPlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicTournamentRosterPlayer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'playerNumber': json['playerNumber'] == null ? undefined : json['playerNumber'],
    };
}

export function PublicTournamentRosterPlayerToJSON(json: any): PublicTournamentRosterPlayer {
    return PublicTournamentRosterPlayerToJSONTyped(json, false);
}

export function PublicTournamentRosterPlayerToJSONTyped(value?: PublicTournamentRosterPlayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'playerNumber': value['playerNumber'],
    };
}

